export default {
  auth: () => import("/home/runner/work/individuallist.xyz/individuallist.xyz/packages/site/src/layouts/auth.vue"),
  default: () => import("/home/runner/work/individuallist.xyz/individuallist.xyz/packages/site/src/layouts/default.vue"),
  empty: () => import("/home/runner/work/individuallist.xyz/individuallist.xyz/packages/site/src/layouts/empty.vue"),
  legal: () => import("/home/runner/work/individuallist.xyz/individuallist.xyz/packages/site/src/layouts/legal.vue")
}